export default "__VITE_ASSET__BLfnWOB___"